<template>
    <TItems
        class="o-d-service d-service"
        footer-button="back"
        :footer-button-text="$t('ui.back')"
        @clickFooterButton="handleClickBack"
    >
        <template #header>
            <OWItemsHeader
                color="#E25046"
                :title="t(service, 'name')"
            >
                <template #left>
                    <div class="d-service__icon-container">
                        <img 
                            class="d-service__icon"
                            :src="t(service, 'icon')" 
                            :alt="t(service, 'name')"
                        >
                    </div>
                </template>
                <template #right>
                    <span class="d-service__info">
                        {{ filteredByItem ? t(service, 'objectsCount') - 1 : t(service, 'objectsCount') }} st
                    </span>
                </template>
            </OWItemsHeader>
        </template>
        <template #main>
            <RecycleScroller
                #default="{ item }"
                :items="items"
                :item-size="87"
                class="o-d-service__scroller"
            >
                <OWServiceInfoTile
                    :item="item"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TItems>
</template>

<script>
import sortBy from "lodash/sortBy";
    
import { mapGetters } from 'vuex';

import TItems from '../../templates/t-items/t-items';
import OWItemsHeader from '../../organisms/o-w-items-header/o-w-items-header';
import OWServiceInfoTile from '../../organisms/o-w-service-info-tile/o-w-service-info-tile';
import {
    GUIDE_JUMP_TO,
    GUIDE_NEW_POINT
} from "@/utils/constants/bus-events-constants";
import { WEB_GUIDE } from '@/utils/constants/pages';

import firstElementTabNavigation from '../../../utils/mixins/first-element-tab-navigations';

import { sortedItems } from '@/utils/helpers/sortedItems'

export default {
    name: 'ODService',
    components: {
        TItems,
        OWItemsHeader,
        OWServiceInfoTile
    },
    mixins: [
        firstElementTabNavigation
    ],
    data() {
        return {
            tabNavigationStartElement: '.w-service-info-tile'
        }
    },
    props: {
        id: {
            type: Number,
            default: null
        },
        guide: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: null
        },
        filteredByItem: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getListItem',
            'getActiveLocale',
            'getObjectsByCategory'
        ]),
        service() {
            return this.id ? this.getListItem(this.id) : this.getListItem(parseFloat(this.$route.query.id));
        },
        items() {

            let items = sortBy(this.getObjectsByCategory(this.service.id), ["distance"]);

            if(this.filteredByItem) items = items.filter(item => item.id !== this.filteredByItem)

            return sortedItems(items, this.getActiveLocale)
        }
    },
    methods: {
        handleClickBack() {
            if (!this.guide) {
                const params = {
                    name: 'web.services'
                };
                this.$router.push(params);
            } else {
                this.$bus.$emit(GUIDE_JUMP_TO, 'services');
            }

        },
        handleTileClick(data) {
            if (this.guide) {
                const params = this.mode === 'start' ? 'start' : 'finish';
                this.$bus.$emit(GUIDE_NEW_POINT, {
                    mode: params,
                    ...data
                });
            } else {
                const params = {
                    name: WEB_GUIDE,
                    params: {
                        type: 'services'
                    },
                    query: {
                        to: data.id
                    }
                };
                this.$router.push(params);
            }
        }
    }
}
</script>

<style lang="scss">
  @import "o-d-service";
</style>